<style>
</style>

<template>
<div id="home--view">
  <v-container grid-list-xs>
    <div v-if="$oauth2.hasAccessToken()">
      <div v-if="hasCustomer && !hasAgreement">
        <customer-gdpr></customer-gdpr>
      </div>
      <div v-else-if="isWelcomeFlag() && progress">
        <v-row mt-3 mb-3>
          <v-col cols="12">
            <div class="headline primary--text">{{ $t('Klientská zóna se otevírá') }}</div>
          </v-col>
        </v-row>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </div>
      <div v-else>
        <v-row mt-3 mb-3>
          <v-col cols="12">
            <div class="headline primary--text">{{ $t('Vítejte v klientské zóně') }}</div>
          </v-col>
          <v-col cols="12" grey--text>
            <div v-if="isRegistered">{{ $t('Jako registrovaný uživatel můžete dále pokračovat do ') }}
              <a @click="toReservations">{{ $t('rezervací') }}</a>
              {{ $t('nebo do našeho ') }}
              <a @click="toEshop">{{ $t('eshopu') }}</a>{{ '.' }}
            </div>
            <div v-else>{{ $t('Jako neregistrovaný uživatel můžete pokračovat do našeho ') }}
              <a @click="toEshop">{{ $t('eshopu') }}</a>{{ $t('. Pokud chcete plně využít naši klientskou zónu, ') }}
              <a @click="signIn">přihlaste</a>{{ $t(' se nebo se ') }}<a @click="newAccount">zaregistrujte</a>{{ '.' }}
            </div>
          </v-col>
          <v-col cols="12" pt-5 class="text-center">
            <v-switch :label="$t('Příště již nezobrazovat')" v-model="welcomeFlag"></v-switch>
          </v-col>
        </v-row>
        <v-progress-linear color="primary" indeterminate v-if="progress"></v-progress-linear>
      </div>
    </div>
  </v-container>
</div>
</template>
<script>
import CustomerGdpr from '@/components/customer-gdpr.vue'
import BasketMixin from '@/mixins/basket-mixin.js'
import CustomerMixin from '@/mixins/customer-mixin.js'
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'
import StorageMixin from '@/mixins/storage-mixin.js'
// const eshop = require('@/oauth2/eshop.json')

export default {
  name: 'HomePage',
  mixins: [BasketMixin, CustomerMixin, InstitutionMixin, StorageMixin],
  components: {
    'customer-gdpr': CustomerGdpr
  },
  data() {
    return {
      gradient: 'to bottom, #B0BEC5, #FFFFFF',
      timer: null,
      welcomeFlag: null,
      progress: true
    }
  },
  mounted() {
    if (this.$oauth2.hasAccessToken()) {
      this.welcomeFlag = this.isWelcomeFlag()
      if ((this.isRegistered && this.hasAgreement) || (!this.isRegistered && this.hasInstitution)) {
        this.delayedNext()
      }
      if (this.isRegistered) {
        this.loadingCustomer = true
        this.fetchCustomer()
          .then(() => this.getGdprStates())
          .then(() => {
            this.loadingCustomer = false
            if (this.hasCustomer !== null) {
              this.fetchCustomerData()
            }
          })
      }
    }
  },
  methods: {
    delayedNext() {
      if (this.isWelcomeFlag()) {
        this.toNext()
      } else {
        this.progress = false
      }
    },
    toNext() {
      const name = (this.isRoute ? this.getRoute() : (!this.isRegistered ? 'eshop' : 'reservations'))
      this.$router.push({
        name: name
      }).catch(console.log)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  watch: {
    hasInstitution(value) {
      if (!this.isRegistered && value) {
        this.delayedNext()
      }
    },
    hasToken(value) {
      if (value) {
        this.delayedNext()
      }
    },
    hasAgreement(value) {
      if (value) {
        this.delayedNext()
      }
    },
    welcomeFlag(value) {
      if (this.hasInstitution && value) {
        this.setWelcomeFlag(true)
        // this.delayedNext()
      }
    }
  }
}
</script>
<style>
</style>
